import { cx } from '@emotion/css';
import { FC } from 'react';
import { useNavigation } from '../context/navigation-context-provider';
import { useContentful } from '../hooks/useContentful';
import { useQuery } from '@tanstack/react-query';
import { getDesignSystemIconWithFallback } from '../helpers/utils';
import { STIHL100YearsLogo } from './STIHL100YearsLogo';

interface AppNameSectionProps {
  increaseLogoSizeOnBreakpoint: 'tablet' | 'desktop';
}

export const AppNameSection: FC<AppNameSectionProps> = ({ increaseLogoSizeOnBreakpoint }) => {
  const { config } = useNavigation();
  const { getStihlLink } = useContentful();

  const homeLinkQuery = useQuery(['STIHL_NAV', 'APP_NAME_SECTION', 'HOME_LINK'], () =>
    getStihlLink(config?.homeLinkId || 'more-of-stihl', config.locale)
  );

  const logoImage = (
    <img
      src={getDesignSystemIconWithFallback('stihl_logo.svg')}
      alt="STIHL"
      data-testid="navigation_logo"
      className={cx('h-[3.125rem]', {
        'desktop:h-[3.75rem]': increaseLogoSizeOnBreakpoint === 'desktop',
        'tablet:h-[3.75rem]': increaseLogoSizeOnBreakpoint === 'tablet',
      })}
    />
  );

  return (
    <div className="flex items-center gap-4 whitespace-nowrap">
      {homeLinkQuery.data?.url ? (
        <a
          href={homeLinkQuery.data.url}
          data-testid="navigation_home-link"
          className="focus-visible:outline-offset-[-2px] focus-visible:outline-[#252525] focus-visible:outline-[2px] focus-visible:outline"
          aria-label={config?.ariaLabelHomeLink}
        >
          {logoImage}
        </a>
      ) : (
        logoImage
      )}
      <STIHL100YearsLogo />
      {config.name && (!config.mainNavItems || config?.shouldHideMainNavOnDesktop) && (
        <div className="hidden stihl-text-highlight-price-sm md:block" data-testid="navigation_appname">
          {config.name.toUpperCase()}
        </div>
      )}
    </div>
  );
};
